import { render, staticRenderFns } from "./device_categories.vue?vue&type=template&id=55b27928&scoped=true&"
import script from "./device_categories.vue?vue&type=script&lang=js&"
export * from "./device_categories.vue?vue&type=script&lang=js&"
import style0 from "./device_categories.vue?vue&type=style&index=0&id=55b27928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b27928",
  null
  
)

export default component.exports